<template lang="">
  <div class="overview-card">
    <p class="c-white d-flex gap-05" v-if="match"><span>📍</span> <span class="ml-20 notranslate"> {{ match.venue && match.venue.name ? match.venue.name : 'TBA' }} </span> </p>
    <p class="c-white d-flex gap-05" v-if="match && match.meta && match.meta.field && match.meta.field.name"><span>🏟</span> <span class="ml-20 notranslate"> {{ fieldDisplayName(match.meta.field) }} </span> </p>
    <p class="c-white d-flex gap-05" v-if="match"><span>🏆</span> <span class="ml-20 notranslate"> {{ match.competition.name || '-' }} {{ getMatchRound }}</span> </p>
    <p class="c-white d-flex gap-05" v-if="match"><span>⌛</span> <span class="ml-20"> {{ formatDateTime(match) }} </span> </p>
    <p class="c-white d-flex gap-05" v-if="match && match.referees && match.referees.length">
      <span>👔</span>
      <span class="referee ml-20 notranslate" v-for="({memberId, firstName, lastName}, index) in match.referees" :key="memberId">
        {{ firstName }} {{ lastName }} {{index !== match.referees.length - 1 ? ', ' : '' }}
      </span>
    </p>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment-timezone';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { mapGetters } from "vuex";

export default {
  name: 'OverviewCard',
  props: {
    match: {
      type: Object,
      required: true
    }
  },
  components: { },
  data() {
    return {
      moment,
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
    }
  },
  methods: {
    fieldDisplayName(field) {
      if (!field || !field.name) return '';
      if (!field.surface || field.surface === 'N/A') return field.name;
      return `${field.name} (${field.surface})`;
    },
    changeDateTimeToTimezone(pools) {
      const timezoneClients = [21, 22];
      if (!timezoneClients.includes(+process.env.VUE_APP_NATIONAL_ID)) {
        return;
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const pool of pools) {
        const { matches } = pool || {};
        // eslint-disable-next-line no-restricted-syntax
        for (const match of matches) {
          const dateTimeTimezone = utcToZonedTime(match.dateTime, this.timezone);
          match.dateTime = dateTimeTimezone.valueOf();
          match.dateTimeTimezone = dateTimeTimezone;
        }
      }
    },
    formatDateTime(match) {
      const matchLocal = _.cloneDeep(match);
      this.changeDateTimeToTimezone([{
        matches: [matchLocal]
      }]);
      const timestamp = matchLocal.dateTime;
      if (!timestamp) return '-';
      const isTomorrow = moment().add(1, 'day').isSame(timestamp, 'day');
      const isToday = moment().isSame(timestamp, 'day');
      const time = moment(timestamp).format('h:mm A');
      if (isToday) {
        return moment(timestamp).format('h:mm A');
      } else if (isTomorrow) {
        return `Tomorrow ${time}`;
      } else {
        return moment(timestamp).format('LLL')
      }
    }
  },
  computed: {
    getMatchRound() {
      if (!this.match || !this.match.round || !this.match.round.number) return '';
      return this.match.round ? `| Round ${this.match.round.number}` : '';
    },
    ...mapGetters('national', ['timezone']),
  }
}
</script>

  <style lang="scss" scoped>

    .overview-card {
      margin-bottom: 1rem;
      padding: 1rem 1.5rem;
      background: #171717;
      border-radius: 24px;
      font-family: 'BrownStd-Regular';
      margin-top: 1.5rem;
      letter-spacing: -.05rem;
      max-width: 768px;
      @media (min-width: 768px) {
        min-width: 768px;
      }
    }

    .bold-title {
      max-width: none;
    }
    .custom-card {
      border-radius: 24px;
      cursor: pointer;
      // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
      // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
      font-family: 'BrownStd-Regular';
      font-size: 1.2rem;
      line-height: 137.4%;
      letter-spacing: 0.02em;
      color: white;
      // background: transparent;
      background: #171717 !important;
      &:hover {
        background: hsl(225, 6%, 14%) !important;
      }
      margin-inline: 1.5rem;
      margin-bottom: 1rem;

      .venue {
        letter-spacing: -0.01rem;
      }

      padding: 0.5rem;
    }

  ion-badge {
    border-radius: 200px;
    height: 1.75rem;
  }

  .date-time {
    margin-top: 0.5rem;
    margin-bottom: -0.25rem;
  }

  .team-name {
    font-family: 'BrownStd-Regular';
    color: #ebebeb;
  }

  .score-text {
    font-size: 1.3rem;
  }


  .custom-card .card-content-ios {
    padding: 10px;
  }

  .custom-card .promoted-header {
    font-family: 'BrownStd-Regular';
    text-align: center;
    font-size: .9rem;
    font-weight: 600;
    text-transform: capitalize;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: #2d3a45;
  }

  .list-ios, .list-md {
    padding: 0;
    background: 0;
  }
  </style>